<template>
	<div>
		<div
			class="modal fade"
			id="importFile"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px"
				>
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">Import File</h5>
						<button type="button" class="close" data-dismiss="modal">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="margin-top:25px;margin-left:270px;width:60%">
						<div class = "form-group row">
							<div v-if = "isFileUploading" class="spinner-border" ></div>
							<div class = "col-md-7" v-else>
								<div v-if = "!fileUploadedName">
									<input
										class="choose"
										type="file"
										placeholder="Import Product From csv"
										multiple="false"
										accept=".xlsx"
										@change="uploadFile"
									>
								</div>
								<div v-show = "fileUploadedName">
									{{fileUploadedName}}
									<i
										style="margin-left:20px"
										class="fa fa-times"
										@click="resetFile()"
									></i>
								</div>
							</div>
							<div v-if = "isbulkUpdation" class = "col-md-5">
								<span>
									<p>We are processing your request....this can take a while..</p>
									<div class="spinner-border" ></div>
						   		</span>
							</div>
							<div v-else class = "col-md-4">
								<div v-if = "isUpdated">
									<p>{{msg}}</p>
								</div>
							</div>
						</div>
					</div>

					<div class="modal-footer">
						<div class="mt-2" style="text-align: center">
							<button type="button" class="btn btn-primary" data-dismiss="modal" @click = "getList">Done</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "ImportFilePopUp",
		components: {
		},
		mounted() {
			//this.openCampaignGroup();
		},
		data() {
			return {
				isFileUploading: false,
				fileUploadedName: "",
				isbulkUpdation:false,
				isUpdated:false,
				msg:''
			};
		},
		watch: {},
		methods: {
			getList(){
			this.$emit("getData");
		//	this.$store.dispatch("accounts/checkIfUpdating")
			},
			uploadFile(evt){
				let file = evt.target.file || evt.target.files[0];
				// let payload = {
				// 	fileName: file.name,
				// 	fileType:  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
				// }

				let vm = this;
				let fileData = "";

				this.isFileUploading = true;

				this.$store.dispatch("accounts/getPresighnedURL").then((res) => {
					let data = {
						url : res.uploadUrl,
						data: file
					}
					vm.$store.dispatch("accounts/uploadFile", data).then(response => {
						vm.isFileUploading = false;

						let payload = {
							uploadUrl: res.uploadUrl,
							downloadUrl: res.downloadUrl,
							name: file.name
						}
						vm.isbulkUpdation = true
						this.$store.dispatch("accounts/updateFileData", payload).then((data) => {
							vm.$store.dispatch("accounts/checkIfUpdating")
							if(data == "Updated"){
								vm.isUpdated = true;
								vm.msg = 'Updated New Data'
							}
						//	vm.isbulkUpdation = false;
							console.log(data);
						})

					//	this.bulkOperate(file)

						console.log(response);
					});
				})
			},
			bulkOperate(file){
				//let data = XLSX.readFile(resp.data, {type: 'buffer'});
			},
			resetFile(){
				this.isFileUploading = false;
				this.fileUploadedName = "";
			}
		}
	};
</script>
<style lang="scss">
</style>
